import SessionStorage from '../app/sessionStorage'

const useSessionStorage = () => {
  const getFromSessionStorage = async (key) => {
    return SessionStorage.getItem(key)
  }

  const setToSessionStorage = async (key, data) => {
    await SessionStorage.setItem(key, data)
  }

  const removeFromSessionStorage = async (key) => {
    await SessionStorage.removeItem(key)
  }

  return {
    getFromSessionStorage,
    setToSessionStorage,
    removeFromSessionStorage
  }
}

export default useSessionStorage
